import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Search } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
      scrolled ? 'glass-effect shadow-soft-lg backdrop-blur-xl bg-white/80' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/cjop348f_image.png" 
              alt="MCT - Meta Cell Technology" 
              className="h-12 w-auto transition-all duration-300 group-hover:opacity-80"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-silver-600 hover:text-teal-500 transition-all duration-300 font-light text-sm tracking-wide">
              Home
            </Link>
            <Link to="/plasma" className="text-silver-600 hover:text-teal-500 transition-all duration-300 font-light text-sm tracking-wide">
              Plasma
            </Link>
            <Link to="/exosomes" className="text-silver-600 hover:text-teal-500 transition-all duration-300 font-light text-sm tracking-wide">
              Exosomes
            </Link>
            <Link to="/contact" className="text-silver-600 hover:text-teal-500 transition-all duration-300 font-light text-sm tracking-wide">
              Contact
            </Link>
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="text-silver-600 hover:text-teal-500 transition-all duration-300"
            >
              <Search className="w-5 h-5" strokeWidth={1.5} />
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-silver-700 hover:text-teal-500 transition-all duration-300"
          >
            {isOpen ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-silver-100 shadow-soft max-h-[70vh] overflow-y-auto">
          <div className="px-6 pt-4 pb-6 space-y-3">
            <Link
              to="/"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/technology"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Technology
            </Link>
            <Link
              to="/exosomes"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Exosomes
            </Link>
            <Link
              to="/prp-enhancement"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              PRP Enhancement
            </Link>
            <Link
              to="/exo-tech-bioimplant"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Exo-Tech Bioimplant
            </Link>
            <Link
              to="/clinical-applications"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Clinical Applications
            </Link>
            <Link
              to="/about"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link
              to="/contact"
              className="block px-4 py-3 text-silver-700 hover:text-teal-500 hover:bg-teal-50 rounded-xl transition-all duration-300 font-light"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      )}

      {/* Search Overlay */}
      {searchOpen && (
        <div className="absolute top-24 left-0 right-0 glass-effect border-t border-silver-100 shadow-soft-lg p-6">
          <div className="max-w-3xl mx-auto">
            <input
              type="text"
              placeholder="Search..."
              className="w-full px-6 py-4 bg-white border border-silver-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent font-light text-lg shadow-soft transition-all duration-300"
              autoFocus
            />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;